// ABテスト用のサービス
export class ABTestService {
    constructor(gTagClient, localStorage) {
        Object.defineProperty(this, "tagClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tagClient = gTagClient;
        this.localStorage = localStorage;
    }
    loadGoogleOptimizeTag() {
        this.tagClient.embedGoogleOptimize();
    }
}
